import React, { useContext, useState } from "react";
import "./test.css";
import { AuthContext } from "../../AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import axios from "axios";
const TestResults = () => {
  const { persantage, questionsAnswers, result ,auth } = useContext(AuthContext);
  

  const totalCount = persantage.length;
const countOfOnes = persantage.filter(num => num === 1).length;
const countOfZeros = totalCount - countOfOnes; // Alternatively, you can filter for zeros

const percentageOfOnes = (countOfOnes / totalCount) * 100;
const percentageOfZeros = (countOfZeros / totalCount) * 100;
const [formData, setFormData] = useState({
  name: "",
  feedback: "",
});
const [submit, setSubmit] = useState(false);
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevFormData) => ({
    ...prevFormData,
    [name]: value,
  }));
};
const handleSubmit = async (e) => {
  e.preventDefault();
  const token = auth.token
  try {
    const response = await axios.post(
      "https://sychoclinicapis.runasp.net/api/Feedbacks",
      formData,{
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}` 
        },
      }
    );
    console.log(response);
    setSubmit(true);
  } catch (error) {
    console.log(error);
  }
  setFormData({
    name: "",
    feedback: "",
  });
};

  return (
    <div>
      <div id="result" className="container py-5">
        <div className=" py-3 d-flex justify-content-center align-items-center flex-column h-100 ">
          <h2 className="pb-1 fw-bold after position-relative ">Test Overview</h2>
          <div className="w-75 mx-auto pt-3 d-flex flex-column back  align-items-center justify-content-between mt-5 mb-4   rounded ">
            <div
              style={{ zIndex: "9", width: "100%" }}
              className="d-flex flex-column   align-items-center justify-content-between"
            >
              <div className="text-center">
                <h4 style={{color:"#dc3545"}} className=" fw-bold">Test Result</h4>
                <p
                  className=" rate  px-4 py-2 rounded"
                  style={{fontSize:"20px",color:"teal", textTransform: "uppercase", fontWeight:"bold",letterSpacing:"2px" }}
                >
                  {result?.predicted_value? result.predicted_value : "please try again"}
                </p>
              </div>
              <div
                style={{
                  width: "150px",
                  height: "150px",
                  borderRadius: "50%",
                  border: "1px solid white",
                }}
                className="d-flex flex-column bg-white border-primary   align-items-center gap-2 py-3"
              >
                <span className="fs-1 fw-bold text-primary">{persantage.length }</span>
                <span className="fs-5 text-primary">out of 28</span>
              </div>
              <div className=" d-flex  align-items-center justify-content-center gap-2  my-4 w-100 px-3 ">
                <span className=" text-teal  ">
                  Answers of "Yes" :
                </span>
                {' '}
                <div
                  style={{
                    height: "17px",
                    width: "70%",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "0px",
                    overflow: "hidden",
                  }}
                  className="progress-bar-container"
                >
                  <div
                    style={{
                      height: "100%",
                      width:`${percentageOfOnes}%`,
                      backgroundColor: "#f20b31",
                      transition: "width 0.5s",
                    }}
                    className="progress-bar"
                  ></div>
                </div>
              </div>
              <div className=" d-flex  align-items-center justify-content-center gap-2  my-4 w-100 px-3 ">
                <span className=" text-teal  ">
                  Answers of "No" :
                </span>
                {' '}
                <div
                  style={{
                    height: "17px",
                    width: "70%",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "0px",
                    overflow: "hidden",
                  }}
                  className="progress-bar-container"
                >
                  <div
                    style={{
                      height: "100%",
                      width:`${percentageOfZeros}%`,
                      backgroundColor: "#2d5fe1",
                      transition: "width 0.5s",
                    }}
                    className="progress-bar"
                  ></div>
                </div>
              </div>

              <div className="rate w-100 text-center py-3">
                <p>
                  {" "}
                  chat online with our model that may can treat your problem{" "}
                </p>
                <Link to='/chatbot' className="btn btn-primary text-white border border-primary rounded-pill px-4 py-2">
                  {" "}
                  Chat Now
                </Link>
              </div>
            </div>
          </div>

          <h2 className="pb-1 fw-bold after position-relative mb-5">
            YOUR ANSWERS
          </h2>
        <div className="border border-teal rounded px-4 py-3 w-75">
        {questionsAnswers&& questionsAnswers.map((item,index)=>{
            const isLastItem = index === questionsAnswers.length - 1;

          return(
            <div key={index}
            className="d-flex flex-row justify-content-between  w-100"
            style={{
              borderBottom: isLastItem ? "none" : "2px solid #eee",
              padding: "10px 8px"
            }}
            >
              <p>{item.question}</p>
              <span style={{color:"teal",fontWeight:"bold"}}>{item.answer}</span>

            </div>


          )
        })}

        </div>
        
        </div>
      </div>

      <div className="rate text-center py-4">
        <h3>Rate this test</h3>

        <div className="d-flex justify-content-around rate-container pt-3   w-75 m-auto">
          <div className="left  justify-content-around ">
            <h4>Rate this test</h4>
            <p>how was your experience ?</p>
          </div>

          <div className="right text-warning bg-worning ">
            <FontAwesomeIcon className="px-1" icon={faStar}/>
            <FontAwesomeIcon className="px-1"  icon={faStar}/>
            <FontAwesomeIcon className="px-1"   icon={faStar}/>
            <FontAwesomeIcon className="px-1"  icon={faStar}/>
            <FontAwesomeIcon className="px-1"  icon={faStar}/>
            
          </div>
        </div>

        <form
        onSubmit={handleSubmit}
          className="d-flex flex-column w-75 mx-auto rate-form align-items-center mt-2 "
        >
          <input type="text"
          className="px-2 py-2 w-100 mb-2 border-0 "
          name="name"
          placeholder=" name "
          value={formData.name}
          onChange={handleInputChange}
          />
          <textarea
            className=" px-2 w-100   "
            placeholder="Your Message..."
            name="feedback"
            value={formData.feedback}
            onChange={handleInputChange}
            id=""
            cols=""
            rows="3"
          ></textarea>
        <button
          className="btn  bg-dark w-15 text-white rounded-pill my-2   py-2 px-2  "
          type="submit"
        >
          {submit ? "thank you":"send"}
          
        </button>
        </form>

      </div>
    </div>
  );
};

export default TestResults;
